import React from "react";
import PropTypes from "prop-types";
import { LinearProgress } from "@mui/material";
import { FileImage, FileSpreadsheet, FileText } from "lucide-react";

import { clx } from "../../../../utils/Helpers";

import "./ClientReports.scss";

const FILE_ICONS = {
  png: FileImage,
  jpg: FileImage,
  xlsx: FileSpreadsheet,
};

/** Shared file row for the upload / download / download-all modals. */
const ClientReportFileRow = ({
  title,
  subtitle,
  fileType,
  progress,
  progressLabel,
  action,
  className,
}) => {
  const Icon = FILE_ICONS[fileType] || FileText;
  const isUploading = typeof progress === "number";

  return (
    <div className={clx("client-report-file-row", className)}>
      <div className="client-report-file-row__body">
        <span className="client-report-file-row__icon" aria-hidden>
          <Icon size={20} strokeWidth={1.75} />
        </span>
        <span className="client-report-file-row__copy">
          <span className="client-report-file-row__title">
            <bdi>{title}</bdi>
          </span>
          {subtitle ? (
            <span className="client-report-file-row__subtitle">{subtitle}</span>
          ) : null}
        </span>
        {isUploading ? (
          <span className="client-report-file-row__percent">
            {progressLabel}
          </span>
        ) : (
          action
        )}
      </div>
      {isUploading ? (
        <LinearProgress
          className="client-report-file-row__progress"
          variant="determinate"
          value={progress}
        />
      ) : null}
    </div>
  );
};

ClientReportFileRow.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  fileType: PropTypes.string,
  progress: PropTypes.number,
  progressLabel: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
};

ClientReportFileRow.defaultProps = {
  subtitle: null,
  fileType: "",
  progress: undefined,
  progressLabel: null,
  action: null,
  className: "",
};

export default ClientReportFileRow;
